import { useEffect, useState } from "react"
import BarChartDateCalendarSelector from "components/Charts/BarChartDateCalendarSelector"
import { changeDateLastTwoMonths, getCaloriesStatsLastTwoMonths } from "redux/reducers/caloriesReducer";
import { Dashboard } from "locale/es";
import { useDispatch, useSelector } from "react-redux";

const PerHourTotalInDay = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const patientId = useSelector(({ patient }) => patient.id)
  const { data, status } = useSelector(({ caloriesData }) => caloriesData.lastTwoMonthsPatientData)
  const chartData = useSelector(({ caloriesData }) => caloriesData.perHourChartTotalCaloriesInDay)

  const dispatch = useDispatch()

  useEffect(() => {
    if (patientId && selectedDate) {
      dispatch(getCaloriesStatsLastTwoMonths(patientId, selectedDate));
    }
  }, [patientId, selectedDate, dispatch]);

  useEffect(() => {
    if (patientId && !!selectedDate && !!status) {
      dispatch(changeDateLastTwoMonths(selectedDate.toISOString()))
    }
  }, [data, dispatch, patientId, selectedDate, status])

  return (
    <BarChartDateCalendarSelector
      dataToShow={chartData}
      title={Dashboard.CALORIES_HOUR}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      minDate={null}
      maxDate={new Date()}
    />
  )
}

export default PerHourTotalInDay